/**
 * Shared Technical section header toggle (expand/collapse, mutual exclusion, home navigation).
 * Invoked from useNewPrimaryItems for the Technical section header toggle.
 */
export type TechnicalSectionToggleContext = {
	areSecondaryNavItemsHidden: boolean,
	areTechnicalSubItemsHidden: boolean,
	handleAutoExpandNavigation: () => void,
	isTechnicalExpanded: boolean,
	/** When true, expand/collapse only — no home navigation (pill zone). */
	skipNavigation?: boolean,
	/** When true with skipNavigation: do not collapse other expandables (pill can open Technical alongside Account/Internal). */
	skipMutualExclusion?: boolean,
	navigateToHomeDestination: () => void,
	setAccountExpanded: (expanded: boolean) => void,
	setAreSecondaryNavItemsHidden: (hidden: boolean) => void,
	setAreTechnicalSubItemsHidden: (hidden: boolean) => void,
	setContentExpanded: (expanded: boolean) => void,
	setInternalExpanded: (expanded: boolean) => void,
	setPerformanceExpanded: (expanded: boolean) => void,
	setTechnicalExpanded: (expanded: boolean) => void,
};

export function executeTechnicalSectionToggle(
	context: TechnicalSectionToggleContext,
): void {
	const {
		areSecondaryNavItemsHidden,
		areTechnicalSubItemsHidden,
		handleAutoExpandNavigation,
		isTechnicalExpanded,
		skipNavigation = false,
		skipMutualExclusion = false,
		navigateToHomeDestination,
		setAccountExpanded,
		setAreSecondaryNavItemsHidden,
		setAreTechnicalSubItemsHidden,
		setContentExpanded,
		setInternalExpanded,
		setPerformanceExpanded,
		setTechnicalExpanded,
	} = context;

	handleAutoExpandNavigation();
	const willExpand = !isTechnicalExpanded;
	if (willExpand) {
		setTechnicalExpanded(true);
		if (!skipMutualExclusion) {
			setAccountExpanded(false);
			setContentExpanded(false);
			setInternalExpanded(false);
			setPerformanceExpanded(false);
		}

		if (!skipNavigation) {
			navigateToHomeDestination();
		}
	} else if (areTechnicalSubItemsHidden && areSecondaryNavItemsHidden) {
		setAreTechnicalSubItemsHidden(false);
		setAreSecondaryNavItemsHidden(false);
	} else {
		setTechnicalExpanded(false);
	}
}
